import { render, staticRenderFns } from "./CommissionSplitTable2.vue?vue&type=template&id=2a7785ca"
import script from "./CommissionSplitTable2.vue?vue&type=script&lang=js"
export * from "./CommissionSplitTable2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports